import React from 'react';
import { Container, Box, Grid, useTheme, useMediaQuery } from '@mui/material';

import { BenefitCard } from '@screens/home/benefits/BenefitCard';
import Clock from '@assets/images/clock.png';
import Phone from '@assets/images/phone.png';
import CreditCard from '@assets/images/credit-card.png';

interface Item {
  title: string;
  subtitle: string;
  image: string;
  items?: string[];
  extras: number;
}

const items: Item[] = [
  {
    title: 'Personaliza tu seguro',
    image: Clock,
    subtitle: 'Elige el tipo de cobertura y agrega sólo lo que tú necesitas',
    extras: 0,
  },
  {
    title: 'Modalidades de pago',
    image: CreditCard,
    subtitle: 'Paga como tú quieras, a 3, 6, 9 ó 12 meses sin intereses.',
    extras: 0,
  },
  {
    title: '¡Estamos contigo!',
    image: CreditCard,
    subtitle:
      'A cualquier hora, el día que sea, antes y después de contratar, nosotros te acompañamos.',
    extras: 0,
  },
  {
    title: '¿Ya checaste nuestra app? ',
    image: Phone,
    subtitle:
      'Lleva tus seguros contigo, encuentra beneficios, renueva y mejora tu póliza, contáctanos rapidísimo si nos necesitas y más...',
    extras: 1,
  },
];

export const Benefits: React.FC = () => {
  const { breakpoints } = useTheme();
  const isTablet = useMediaQuery(breakpoints.down('md'));
  return (
    <Container maxWidth={'lg'}>
      <Box
        sx={{ flexGrow: 1 }}
        style={{
          marginTop: 50,
          marginBottom: 50,
        }}
      >
        <Grid container spacing={{ xs: 0, sm: 0, md: 2 }}>
          {items.map((item, i) => (
            <BenefitCard
              key={i}
              item={item}
              hasDivider={isTablet && i !== 3}
              style={{
                borderTopLeftRadius: i === 0 ? 8 : 0,
                borderTopRightRadius: i === 0 ? 8 : 0,
                borderBottomLeftRadius: i === 3 ? 8 : 0,
                borderBottomRightRadius: i === 3 ? 8 : 0,
              }}
            />
          ))}
        </Grid>
      </Box>
    </Container>
  );
};
